export const UserRoleManagementMenuRoutes = {
  DEFAULT: '/management',
  USER_ROLE_MANAGEMENT: '/management',
};
